import React, { useEffect, useState, useCallback, useMemo } from "react";
import LightBoxHeader from "./LightBoxHeader.js";
import LightBoxContent from "./LightBoxContent.js";
import LightBoxFooter from "./LightBoxFooter.js";
import { CSSTransition } from "react-transition-group";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LightBoxSlider } from "./LightBoxSlider.js";

import "./LightBoxManager.scss";

const DefaultContainer = ({ ignoreUrl }) => {
  const { getFileId } = useLightBox();
  const [animationTrigger, setAnimationTrigger] = useState(false);
  const { getDirection } = useContent();
  const navigate = useNavigate();

  const { getMailId, setFileId } = useMail();
  const location = useLocation();

  // START RERENDERING PROTECTION SECTION
  const validationSomeFileOpened = location.pathname.includes(
    getMailId() + "/"
  );

  useEffect(() => {
    document.body.classList.add("stop-scroll");
    setAnimationTrigger(true);
    if (!ignoreUrl) {
      if (!validationSomeFileOpened) {
        const newUrl = location.pathname + "/" + getFileId() + location.search;
        navigate(newUrl);
      }
    }
    return () => {
      setFileId(null);
      document.body.classList.remove("stop-scroll");
      if (!ignoreUrl) {
        const index =
          location.pathname.indexOf(getMailId()) + getMailId().length;
        const newUrl = location.pathname.slice(0, index) + location.search;
        navigate(newUrl);
      }
    };
  }, []);

  useEffect(() => {
    if (!ignoreUrl) {
      if (validationSomeFileOpened) {
        const index =
          location.pathname.indexOf(getMailId()) + getMailId().length;
        const newUrl = location.pathname.slice(0, index) + "/" + getFileId();
        navigate(newUrl);
      }
    }
  }, [getFileId()]);
  // END RERENDERING PROTECTION SECTION

  return (
    <CSSTransition
      in={animationTrigger}
      classNames="lightBox-animation"
      timeout={300}
    >
      <div
        className={`lightBox-overlay ${getDirection()}`}
        onContextMenu={(e) => {
          e.preventDefault();
          return false;
        }}
      >
        <div className="lightBox" onClick={(e) => e.stopPropagation()}>
          <LightBoxHeader ignoreUrl={ignoreUrl} />
          <LightBoxContent>
            <LightBoxSlider />
          </LightBoxContent>
          <LightBoxFooter />
        </div>
      </div>
    </CSSTransition>
  );
};

export default DefaultContainer;
